import Phaser from "phaser";
import { GAME_HEIGHT, GAME_WIDTH } from "./constants";
import { BootScene } from "./scenes/BootScene";
import { MenuScene } from "./scenes/MenuScene";
import { HowToPlayScene } from "./scenes/HowToPlayScene";
import { GameScene } from "./scenes/GameScene";
import { PauseScene } from "./scenes/PauseScene";
import { ResultsScene } from "./scenes/ResultsScene";
import { GameOverScene } from "./scenes/GameOverScene";
import { HighScoresScene } from "./scenes/HighScoresScene";
import { FarewellScene } from "./scenes/FarewellScene";

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game-container",
  backgroundColor: "#1a3a28",
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    autoRound: true,
    expandParent: false,
    fullscreenTarget: "game-container",
  },
  fps: {
    target: 60,
    limit: 60,
    smoothStep: true,
  },
  render: {
    pixelArt: false,
    antialias: true,
    powerPreference: "high-performance",
    batchSize: 4096,
  },
  input: {
    keyboard: {
      capture: [
        Phaser.Input.Keyboard.KeyCodes.LEFT,
        Phaser.Input.Keyboard.KeyCodes.RIGHT,
        Phaser.Input.Keyboard.KeyCodes.UP,
        Phaser.Input.Keyboard.KeyCodes.DOWN,
        Phaser.Input.Keyboard.KeyCodes.W,
        Phaser.Input.Keyboard.KeyCodes.A,
        Phaser.Input.Keyboard.KeyCodes.S,
        Phaser.Input.Keyboard.KeyCodes.D,
        Phaser.Input.Keyboard.KeyCodes.SPACE,
        Phaser.Input.Keyboard.KeyCodes.ESC,
      ],
    },
  },
  scene: [
    BootScene,
    MenuScene,
    HowToPlayScene,
    GameScene,
    PauseScene,
    ResultsScene,
    GameOverScene,
    HighScoresScene,
    FarewellScene,
  ],
};
